import type { FC, SVGAttributes } from 'react';
import React from 'react';

export const IconCross: FC<SVGAttributes<SVGElement>> = props => (
    <svg height="12" viewBox="0 0 12 12" width="12" {...props}>
        <path
            d="M11.5 1.5a.707.707 0 00-1-1L.498 10.498a.707.707 0 001 1L11.5 1.5z"
            fill="currentColor"
        />
        <path
            d="M10.501 11.5a.707.707 0 101-1L1.5.5a.707.707 0 00-1 1l10 10z"
            fill="currentColor"
        />
    </svg>
);
